import { OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ReceiptService } from 'app/services/receipt-service';
var ProductLastReceiptComponent = /** @class */ (function () {
    function ProductLastReceiptComponent(receiptService, router) {
        this.receiptService = receiptService;
        this.router = router;
        /** Opciones del desplegable PAGAR (mismas que en el listado de recibos del perfil). */
        this.payActions = [];
    }
    ProductLastReceiptComponent.prototype.ngOnChanges = function () {
        this.payActions = this.data ? this.buildPayActions() : [];
    };
    Object.defineProperty(ProductLastReceiptComponent.prototype, "canPay", {
        /** El recibo está pendiente (rojo) y no es un extorno, o es un documento de cobro pendiente. */
        get: function () {
            if (!this.data || 'red' !== this.data.receiptStatusColor) {
                return false;
            }
            return 'E' !== this.data.receiptType || !!this.data.docCobroNumber;
        },
        enumerable: true,
        configurable: true
    });
    ProductLastReceiptComponent.prototype.pay = function () {
        this.receiptService.payment(this.data);
    };
    ProductLastReceiptComponent.prototype.buildPayActions = function () {
        var _this = this;
        return [
            {
                label: 'Tarjeta',
                icon: 'card',
                action: function () { return _this.pay(); }
            },
            {
                label: 'Cuenta bancaria',
                icon: 'bank',
                action: function () { return _this.router.navigate(['/receipt', 'nw', _this.data.receiptNumber]); }
            }
        ];
    };
    return ProductLastReceiptComponent;
}());
export { ProductLastReceiptComponent };
